import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import HomepageV2 from "../components/homepage-v2/HomepageV2";
import { HOME_ROUTE } from "../constants/route-constants";
import { getRouteLocalizationNamespaces } from "../methods/getRouteLocalizationNamespaces";

export default function Page() {
    return <HomepageV2 />;
}

export async function getStaticProps({ locale }: { locale: string }) {
    return {
        props: {
            route: HOME_ROUTE,
            ...(await serverSideTranslations(locale, getRouteLocalizationNamespaces("/")))
        }
    };
}
